const parameterRouter = [
    {
        path:'',
        name:'parameter-index',
        component: () => import(/* webpackChunkName: "about" */ '../views/parameter/index.vue'),
    },
  ]
  export default parameterRouter

  